<template>
  <div>
    <el-dialog title="服务者上线信息完善" :visible.sync="addVisible" width="1390px" :close-on-click-modal="false" center>
      <div>
        <el-steps :active="stepStatus" finish-status="success" align-center>
          <el-step title="信息完善" description="身份证识别" />
          <el-step title="背调" description="安全信息检测" />
          <el-step title="签约" description="电子合同签订" />
          <el-step title="上线审核" description="发起上线审核" />
        </el-steps>
      </div>
      <p style="color: red" v-if="TimeFlag">服务超时，请刷新页面</p>
      <!-- <div class="share-servant-wrapper">
        <el-button type="text" v-if="!isIdcard" @click="switchIdReadWays()">
          <i class="el-icon-sort"></i>切换为身份证读卡器识别
        </el-button>
        <el-button type="text" v-if="isIdcard" @click="switchIdReadWays()">
          <i class="el-icon-sort"></i>切换为身份证OCR识别
        </el-button>
      </div> -->
      <el-row v-if="!isIdcard && stepStatus == 1" style="height:376px">
        <div class="readCardTip">证件照片识别信息</div>
        <div style="color:red;font-size:14px;margin:8px 0px 20px 28px;overflow:hidden">
          注意：支持5M以内，png，jpg，jpeg格式上传，要求边缘完整，无明显反光，尽可能清晰可辨识。
          <el-button type="primary" style="float:right" plain @click="confIdentifyBtn">确认识别</el-button>
        </div>
        <el-form :inline="true" size="small" :model="servantIdCardPic" ref="servantIdCardPic" label-width="150px"
          class="servantIdCardPic" :rules="rules">
          <el-row>
            <el-col :span="12">
              <el-form-item label="上传正面照片" style="height:139px">
                <el-upload class="upload-demo" action="123" :limit="1" :on-remove="handleRemoveA"
                  accept=".png, .jpg, jpeg" :file-list="[]" list-type="picture" :on-change="handleOnChangeA"
                  :before-upload="beforeAvatarUploadA" :auto-upload="false">
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="上传反面照片">
                <el-upload class="upload-demo" action="123" :on-remove="handleRemoveB" accept=".png, .jpg, jpeg"
                  :file-list="[]" list-type="picture" :on-change="handleOnChangeB" :auto-upload="false">
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="text-align:center"></el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="姓名：">{{ servantIdCardPic.cidName }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="性别：">
                <span>{{ servantIdCardPic.cidGender }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="年龄：">{{ servantIdCardPic.age }}</el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="身份证号码：">{{ servantIdCardPic.cidNumber }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="籍贯：">{{ servantIdCardPic.logicBornplace }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="生日：">{{ servantIdCardPic.birthday }}</el-form-item>
            </el-col>
          </el-row>
          <el-row>

            <el-col :span="8">
              <el-form-item label="身份证有效期：">{{ servantIdCardPic.validPeriodDate }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="星座：">{{ servantIdCardPic.logicZodiac }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="属相：">{{ servantIdCardPic.logicAnimalSign }}</el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16">
              <el-form-item label="身份证地址：">{{ servantIdCardPic.cidAddr }}</el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-row>
      <el-row class="mideleLine" v-if="stepStatus == 1">
        <el-form :inline="true" size="small" :model="servantHandleInfo" ref="servantHandleInfo" label-width="150px"
          class="servantHandleInfo" :rules="rules">
          <div v-if="isIdcard">
            <div class="readCardTip">身份证读卡器信息</div>
            <el-row>
              <el-col :span="8">
                <el-form-item label="姓名" prop="cidName">
                  <el-input v-model.trim="servantHandleInfo.cidName" style="width:220px" placeholder clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="性别" prop="gender">
                  <el-select v-model="servantHandleInfo.cidGender" placeholder="全部" style="width:220px">
                    <el-option label="男" value="1">男</el-option>
                    <el-option label="女" value="2">女</el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="年龄" prop="age">
                  <el-input v-model.number="age" style="width:220px" placeholder clearable><template
                      slot="append">岁</template></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="生日" prop="birthday">
                  <el-date-picker v-model="servantHandleInfo.birthday" type="date" placeholder="选择日期"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="籍贯">
                  <el-select v-model="servantHandleInfo.logicBornplace" filterable clearable style="width:220px">
                    <el-option v-for="item in birthplaceList" :key="item.index" :label="item" :value="item"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="身份证号码" prop="cidNumber">
                  <el-input v-model="servantHandleInfo.cidNumber" style="width:220px" maxlength="18" show-word-limit
                    placeholder clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="属相">
                  <el-select v-model="servantHandleInfo.logicAnimalSign" placeholder="全部" filterable style="width:220px">
                    <el-option v-for="item in zodiacList" :key="item.index" :label="item" :value="item"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="星座">
                  <el-select v-model="servantHandleInfo.logicZodiac" placeholder="全部" filterable style="width:220px">
                    <el-option v-for="item in constellationList" :key="item.index" :label="item"
                      :value="item"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="16">
                <el-form-item label="身份证地址">
                  <el-input v-model="servantHandleInfo.cidAddr" style="width:570px" placeholder clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="身份证有效期开始时间" prop="startTime" label-width="170px">
                  <el-date-picker v-model="servantHandleInfo.startTime" type="date" placeholder="选择日期"></el-date-picker>
                </el-form-item>
                <el-form-item label="身份证有效期结束时间" prop="endTime" label-width="170px">
                  <el-date-picker v-model="servantHandleInfo.endTime" type="date" placeholder="选择日期"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="readCardTip" style="margin:15px 0px 15px 0px">基础信息</div>

          <!-- <el-row>
            <el-col :span="8">
              <el-form-item label="保姆电话" prop="servantTel">
                <el-input v-model.trim="servantHandleInfo.servantTel" placeholder maxlength="11" show-word-limit clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="民族">
                <el-select v-model="servantHandleInfo.nation" placeholder="全部" filterable width="100px">
                  <el-option v-for="item in nationList" :key="item.index" :label="item" :value="item"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="宗教信仰">
                <el-input v-model="servantHandleInfo.religion" placeholder clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->

          <!-- <el-row>
            <el-col :span="8">
              <el-form-item label="婚姻情况">
                <el-select v-model="servantHandleInfo.marriage" placeholder="请选择">
                  <el-option label="未婚" value="1"></el-option>
                  <el-option label="已婚" value="2"></el-option>
                  <el-option label="离异" value="3"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="生育情况">
                <el-select v-model="servantHandleInfo.bear" placeholder="请选择">
                  <el-option label="已育" value="1"></el-option>
                  <el-option label="未育" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="学历">
                <el-select v-model="servantHandleInfo.education" placeholder="全部" width="100px">
                  <el-option label="小学" value="小学"></el-option>
                  <el-option label="初中" value="初中"></el-option>
                  <el-option label="高中" value="高中"></el-option>
                  <el-option label="专科" value="专科"></el-option>
                  <el-option label="本科" value="本科"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="工作经验">
                <el-select v-model="servantHandleInfo.workExperience" placeholder="请选择">
                  <el-option label="无经验" value="无经验"></el-option>
                  <el-option label="0~1年" value="0~1年"></el-option>
                  <el-option label="1~3年" value="1~3年"></el-option>
                  <el-option label="3~5年" value="3~5年"></el-option>
                  <el-option label="5年以上" value="5年以上"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="普通话">
                <el-select v-model="servantHandleInfo.mandarin" placeholder="全部" width="100px">
                  <el-option label="较差" value="较差"></el-option>
                  <el-option label="合格" value="合格"></el-option>
                  <el-option label="良好" value="良好"></el-option>
                  <el-option label="优秀" value="优秀"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="服务意向">
                <el-select v-model="servantHandleInfo.serviceModel" placeholder="请选择" clearable multiple>
                  <el-option v-for="item in serviceModelList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row> -->
          <!-- <el-row>
            <el-col :span="8">
              <el-form-item label="保姆昵称" prop="nickname">
                <el-input v-model="servantHandleInfo.nickname" placeholder clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="紧急联系人" prop="emergencyContact">
                <el-input v-model="servantHandleInfo.emergencyContact" placeholder clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="紧急联系人电话" prop="emergencyPhone">
                <el-input v-model.trim="servantHandleInfo.emergencyPhone" placeholder maxlength="11" show-word-limit clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->
          <el-row>
            <el-col :span="6">
              <el-form-item label="服务渠道" prop="serviceChannel" label-width="80px">
                <el-select v-model="servantHandleInfo.serviceChannel" style="width:100%" placeholder="请选择" filterable>
                  <el-option :value="1" label="盒马" />
                  <el-option :value="2" label="私域" />
                  <el-option :value="3" label="公用"/>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="所属民族" label-width="80px">
                <el-select v-model="servantHandleInfo.nation" placeholder="全部" filterable>
                  <el-option v-for="item in nationList" :key="item.index" :label="item" :value="item"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="身高" prop="height" label-width="80px">
                <el-input v-model.number="servantHandleInfo.height" placeholder clearable style="width:210px">
                  <template slot="append">cm</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="体重" prop="weight" label-width="80px">
                <el-input v-model.number="servantHandleInfo.weight" style="width:210px" placeholder="请输入体重" clearable>
                  <template slot="append">kg</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item label="接单方式" prop="serviceOrderAllot" label-width="80px">
                <el-select v-model="servantHandleInfo.serviceOrderAllot" style="width:100%" placeholder="请选择接单方式"
                  filterable>
                  <el-option :value="1" label="距离优先-不可跨区" />
                  <el-option :value="2" label="距离优先-可跨区" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="商家运营" prop="workerManagerId" label-width="80px">
                <el-select v-model="servantHandleInfo.workerManagerId" style="width:100%" placeholder="请选择商家运营"
                  filterable>
                  <el-option v-for="item in workerManager" :label="item.name" :value="item.id" :key="item.id" />
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="保底金额" label-width="80px">
                <el-input type="number" v-model="servantHandleInfo.guaranteeAmount" style="width:210px" placeholder
                  clearable>
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="保底期限" label-width="80px">
                <el-date-picker v-model="servantHandleInfo.guaranteeDate" value-format="yyyy-MM-dd" type="daterange"
                  style="width:240px" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"
                  :picker-options="{}"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row>
            <el-col :span="16">
              <el-form-item label="现住地址">
                <el-input v-model="servantHandleInfo.currentAddress" placeholder clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="评语">
                <el-input type="textarea" v-model="servantHandleInfo.comments" placeholder clearable :rows="5" style="width:800px;"></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->
        </el-form>
      </el-row>
      <!-- 背调展示信息 -->
      <div v-if="stepStatus != 1" style="height:506px;display: flex;justify-content: center;align-items: center;">
        <div style="font-size:32px" v-if="stepStatus == 2">信息完善成功，点击下方按钮”<span style="color:red">背调</span>"，完成信息检测</div>
        <span style="font-size:32px" v-if="stepStatus == 3">恭喜背调成功，点击下方按钮”<span style="color:red">签约</span>"签订电子合同</span>
        <span style="font-size:32px" v-if="stepStatus == 4">点击下方按钮”<span style="color:red">发起上线审批</span>"，等待上级审批</span>
        <!--恭喜成为鲸致员工， -->
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelAddServantBtn('servantHandleInfo')">取消</el-button>
        <el-button type="primary" v-if="stepStatus == 1" icon="el-icon-info"
          @click="confAddServantBtn('servantHandleInfo')">完善信息</el-button>
        <el-button type="primary" v-if="stepStatus == 2" icon="el-icon-check"
          @click="handleInvestigation()">背调</el-button>
        <el-button type="primary" v-if="stepStatus == 3" icon="el-icon-key" @click="handleSign()">签约</el-button>
        <el-button type="primary" v-if="stepStatus == 4" icon="el-icon-user" @click="handleJoin()">发起上线审批</el-button>
      </span>
    </el-dialog>

    <!-- 新增工作经历 -->
    <el-dialog title="新增工作经历" :visible.sync="workExpVisible" width="500px" :close-on-click-modal="false" center>
      <el-form :inline="true" size="small" :rules="addRules" ref="servantWorkExpForm" :model="servantWorkExpForm"
        label-width="110px">
        <el-form-item label="开始时间" prop="startTime">
          <el-date-picker v-model="servantWorkExpForm.startTime" type="date" placeholder="选择日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="endTime">
          <el-date-picker v-model="servantWorkExpForm.endTime" type="date" placeholder="选择日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="工作内容" prop="workContent">
          <el-input v-model="servantWorkExpForm.workContent" placeholder clearable></el-input>
        </el-form-item>
        <el-form-item label="工作描述" prop="workDesc">
          <el-input style="width:215px" v-model="servantWorkExpForm.workDesc" type="textarea" :rows="2" placeholder
            clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelAddWorkExpBtn('servantWorkExpForm')">取消</el-button>
        <el-button type="primary" :loading="addLoading" @click="confAddWorkExpBtn('servantWorkExpForm')">确定</el-button>
      </span>
    </el-dialog>

    <!-- 重复提示 -->
    <el-dialog title="提示" :visible.sync="tipVisible" width="500px" :close-on-click-modal="false" center>
      <p style="color:red;margin:10px 0px;">{{ resfranch }}</p>
      <!-- <p style="color:red;margin:10px 0px;">此保姆已在 {{resfranch}} 名下，不能重复录入！</p>
            <p v-if="resCardID">身份证号：{{resCardID}}</p>-->
      <span slot="footer" class="dialog-footer">
        <el-button @click="tipVisible = false">取消</el-button>
      </span>
    </el-dialog>

    <!--保洁服务合作协议-->
    <signBaodi ref="signBaodi" />
  </div>
</template>
<script>
//servantRecommend
import "@/components/workercrm/css/index.css";
import commutilData from "@/components/common/commutil.data";
import workercrmapi from "@/script/api/workercrmapi";
import signBaodi from "@/components/workercrm/contract/compent/signBaodi";
import moment from "moment";
import {
  validatePhoneTwo,
  validateIdNo,
  validateIdNoOrNull,
  validateNumber,
} from "@/script/validator";
import globalData from "@/components/common/globaldata/global.data.vue";
import ajaxStorage from "@/script/api/storage.js";
import lrz from "lrz";
export default {
  components: { signBaodi },
  data() {
    return {
      workerManager: [],
      cityId: "",
      buzLine: "",
      stepStatus: 1, //表示上线已完成到第几步：1信息完善 2背调 3签约 4正式上线
      workerSupplierId: "",
      fileFrontPhoto: "",
      fileBackPhoto: "",
      isIdcard: false,
      serviceModelList: commutilData.serviceModelList,
      resCardID: "",
      resmessageres: "",
      resfranch: "",
      readMsgState: false,
      workIdCardWrong: "",
      workIdCardScore: "",
      workIdCardReason: "",
      workIdCard: "",
      workerResource: "",
      phoneWorker: "",
      tipVisible: false,
      nationList: commutilData.nationList, //民族
      zodiacList: commutilData.zodiacList, //生肖
      constellationList: commutilData.constellationList, //星座
      birthplaceList: commutilData.birthplaceList, //籍贯
      addVisible: false,
      workExperienceData: [],
      addLoading: false,
      workExpVisible: false,
      servantIdCardPic: {
        cidName: "",
        cidNumber: "",
        cidAddr: "",
        logicBornplace: "",
        birthday: "",
        logicAnimalSign: "",
        frontIdcardFullPath: "",
        frontIdcardName: "",
        backIdcardFullPath: "",
        backIdcardName: "",
        validPeriodDate: "",
        age: "",
        idValidityEnddate: "",
        idValidityStartdate: "",
        frontIdcardurl: "",
        backIdcardurl: "",
      },
      servantWorkExpForm: {
        startTime: "",
        endTime: "",
        workContent: "",
        workDesc: "",
      },
      servantHandleInfo: {
        nation: "",
        religion: "",
        servantTel: "",
        marriage: "",
        workExperience: "",
        mandarin: "",
        serviceModel: "",
        currentAddress: "",
        bear: "",
        education: "",
        emergencyContact: "",
        emergencyPhone: "",
        cidName: "",
        cidNumber: "",
        cidAddr: "",
        logicBornplace: "",
        logicAnimalSign: "",
        birthday: "",
        startTime: "",
        endTime: "",
        nickname: "",
        weight: "",
        height: "",
        comments: "",
        isGold: "0",
        guaranteeAmount: null,
        guaranteeStart: null,
        guaranteeEnd: null,
        guaranteeDate: [],
        workerManagerId: ''
      },
      userAccount: "",
      date: "",
      mysetInterval: "",
      age: "",

      required: {},
      intervalTimes: 0,
      TimeFlag: false,
      rules: {
        // franchiseeName:[{ required: true, message: '请输入合伙人全名', trigger: 'blur' }],
        // servantTel: [
        //   { required: true, message: "请填写保姆电话", trigger: "blur" },
        //   {
        //     validator: validatePhoneTwo,
        //     message: "手机号格式错误",
        //     trigger: "blur",
        //   },
        // ],
        // emergencyPhone: [
        //   { required: true, message: "请填写紧急联系人电话", trigger: "blur" },
        //   {
        //     validator: validatePhoneTwo,
        //     message: "手机号格式错误",
        //     trigger: "blur",
        //   },
        // ],
        serviceChannel: [{ required: true, message: "请选择服务渠道", trigger: "blur" }],
        serviceOrderAllot: [{ required: true, message: "请选择接单举例", trigger: "blur" }],
        cidName: [{ required: true, message: "请填写姓名", trigger: "blur" }],
        cidNumber: [
          { required: true, message: "请填写身份证号码", trigger: "blur" },
          {
            validator: validateIdNoOrNull,
            message: "身份证号码格式错误",
            trigger: "blur",
          },
        ],
        startTime: [
          {
            required: true,
            message: "请选择身份证有效期开始时间",
            trigger: "change",
          },
        ],
        endTime: [
          {
            required: true,
            message: "请选择身份证有效期结束时间",
            trigger: "change",
          },
        ],
        birthday: [
          { required: true, message: "请选择生日日期", trigger: "change" },
        ],
        height: [
          { pattern: new RegExp(/^[1-9]\d*$/, "g"), message: "请输入数字!" },
        ],
        weight: [
          { pattern: new RegExp(/^[1-9]\d*$/, "g"), message: "请输入数字!" },
        ],
        age: [
          { pattern: new RegExp(/^[1-9]\d*$/, "g"), message: "请输入数字!" },
        ],
      },
      addRules: {
        startTime: [
          { required: true, message: "请选择开始日期", trigger: "change" },
        ],
        endTime: [
          { required: true, message: "请选择结束日期", trigger: "change" },
        ],
        workContent: [
          { required: true, message: "请填写工作内容", trigger: "blur" },
        ],
        workDesc: [
          { required: true, message: "请填写工作描述", trigger: "blur" },
        ],
      },
      workerInfo: {}
    };
  },

  methods: {
    addServantData(workerSupplierId, cityId, buzLine, stepStatus, date, row) {
      this.getWorkerManager();
      this.cityId = cityId;
      this.buzLine = buzLine;
      this.workerSupplierId = workerSupplierId;
      this.stepStatus = stepStatus;
      this.fileFrontPhoto = "";
      this.fileBackPhoto = "";
      this.isIdcard = false;
      this.servantIdCardPic = {
        cidName: "",
        cidNumber: "",
        cidAddr: "",
        logicBornplace: "",
        birthday: "",
        logicAnimalSign: "",
        frontIdcardFullPath: "",
        frontIdcardName: "",
        backIdcardFullPath: "",
        backIdcardName: "",
        validPeriodDate: "",
        age: "",
        idValidityEnddate: "",
        idValidityStartdate: "",
        frontIdcardurl: "",
        backIdcardurl: "",
      };
      this.readMsgState = false;
      this.TimeFlag = false;
      this.addVisible = true;
      this.userAccount = globalData.userInfo.userAccount;
      this.date = date;
      this.servantHandleInfo = {
        nation: "",
        religion: "",
        servantTel: "",
        marriage: "",
        workExperience: "",
        mandarin: "",
        serviceModel: "",
        currentAddress: "",
        bear: "",
        cidGender: "",
        education: "",
        emergencyContact: "",
        emergencyPhone: "",
        cidName: "",
        cidNumber: "",
        cidAddr: "",
        logicBornplace: "",
        logicAnimalSign: "",
        startTime: "",
        endTime: "",
        birthday: "",
        nickname: "",
        weight: "",
        height: "",
        comments: "",
        guaranteeAmount: null,
        guaranteeStart: null,
        guaranteeEnd: null,
        guaranteeDate: [],
        serviceChannel: 1,
        serviceOrderAllot: 2,
        workerManagerId: ''
      };
      this.startTime = "";
      this.endTime = "";
      this.birthday = "";
      this.age = "";
      this.workExperienceData = [];
      this.workerInfo = row;
    },
    //确定新增商家
    confAddServantBtn(formName) {
      if (this.servantIdCardPic.cidName == "" && this.isIdcard == false) {
        this.$message.warning("请上传身份证正反面照片，再点击‘确认识别’按钮！");
        return;
      }
      console.log(this.readMsgState);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let agent = {
            id: this.workerSupplierId,
            cityId: this.cityId,
            buzLine: this.buzLine,
            weight: this.servantHandleInfo.weight,
            height: this.servantHandleInfo.height,
            comments: this.servantHandleInfo.comments,
            birthday: this.servantIdCardPic.birthday,
            constellation: this.servantIdCardPic.logicZodiac,
            gender: this.servantIdCardPic.gender,
            workerIdcard: this.servantIdCardPic.cidNumber,
            idCardAddress: this.servantIdCardPic.cidAddr,
            idcardEnddate: moment(
              this.servantIdCardPic.idValidityStartdate
            ).format("YYYY-MM-DD"),
            idcardStartdate: moment(
              this.servantIdCardPic.idValidityEnddate
            ).format("YYYY-MM-DD"),
            nation: this.servantHandleInfo.nation,
            isDoIdcard: this.readMsgState == true ? 1 : 0,
            workerName: this.servantIdCardPic.cidName,
            nativePlace: this.servantIdCardPic.logicBornplace,
            updateUserId: globalData.userInfo.id,
            updateUserName: globalData.userInfo.userName,
            // resumeVO: this.workExperienceData,
            zodiac: this.servantIdCardPic.logicAnimalSign,
            idcardFront: this.servantIdCardPic.frontIdcardurl,
            idcardBack: this.servantIdCardPic.backIdcardurl,
            postStationId: this.workerInfo.postStationId,
            guaranteeAmount: this.servantHandleInfo.guaranteeAmount,
            serviceChannel: this.servantHandleInfo.serviceChannel,
            serviceOrderAllot: this.servantHandleInfo.serviceOrderAllot,
            workerManagerId: this.servantHandleInfo.workerManagerId
            // guaranteeStart:null,
            // guaranteeEnd:null,
            // guaranteeDate:[]
          };
          if (this.servantHandleInfo.guaranteeDate != null && this.servantHandleInfo.guaranteeDate.length > 0) {
            agent.guaranteeStart = this.servantHandleInfo.guaranteeDate[0] + " 00:00:00";
            agent.guaranteeEnd = this.servantHandleInfo.guaranteeDate[1] + " 23:59:59";
          }

          console.log(agent);
          workercrmapi
            .$axiosWorkerPerfectWorkerBase(agent)
            .then((res) => {
              if (res.data.errno == 0) {
                this.$message.success("信息完善成功");
                // this.tipVisible = false;
                this.$parent.querySearch();
                this.stepStatus = 2;
              } else {
                this.tipVisible = true;
                this.resfranch = res.data.data;
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          console.log("err");
        }
      });
    },
    handleInvestigation() {
      //背调
      let tmep = {
        workerSupplierId: this.workerSupplierId,
        operatorId: globalData.userInfo.id,
        operatorName: globalData.userInfo.userName,
      };
      workercrmapi.$axiosWorkerInvestigation(tmep).then((res) => {
        if (res.data.errno == 0) {
          this.$message.success("背调成功");
          this.$parent.querySearch();
          this.stepStatus = 3;
        }
      });
    },
    handleSign() {
      //签约
      this.$refs.signBaodi.showDetail(this.workerInfo.workerNo);
      this.addVisible = false;
      this.$emit('querySearch');

      // let tmep = {
      //   id: this.workerSupplierId,
      //   signContractState: 1,
      // };
      // workercrmapi.$axiosWorkerUpdateSignContractState(tmep).then((res) => {
      //   if (res.data.errno == 0) {
      //     this.$message.success("签约成功，可以上线");
      //     this.$parent.querySearch();
      //     this.stepStatus = 4;
      //   }
      // });
    },
    handleJoin() {
      //正式上线
      let tmep = {
        id: this.workerSupplierId,
        operId: globalData.userInfo.id,
        operName: globalData.userInfo.userName,
      };

      workercrmapi.$axiosWorkerInduction(tmep).then((res) => {
        if (res.data.errno == 0) {
          this.$message.success("提交成功，等待审批");
          this.$parent.querySearch();
          this.addVisible = false;
          this.tipVisible = false;
        }
      });
    },
    //确认识别身份证照片
    confIdentifyBtn() {
      console.log(this.fileFrontPhoto);
      if (this.fileFrontPhoto == null || this.fileBackPhoto == null
        || this.fileFrontPhoto == "" || this.fileBackPhoto == "") {
        this.$message.warning("请上传身份证正面照片或反面照片！");
        return false;
      }
      const loading = this.$loading({
        lock: true,
        text: "正在识别身份证照片中，请耐心等候...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      let temp = new FormData();
      temp.append("workerSupplierId", this.workerSupplierId);
      temp.append("frontPhoto", this.fileFrontPhoto);
      temp.append("backPhoto", this.fileBackPhoto);
      temp.append("operatorId", globalData.userInfo.id);
      temp.append("operatorName", globalData.userInfo.userName);

      workercrmapi
        .$axiosWorkerOcrVerify(temp)
        .then((res) => {
          loading.close();
          this.readMsgState = true;
          if (res.data.errno == 0) {
            if (res.data.data.code == "C0" && res.data.data.overCode == 0) {
              this.$message.success(res.data.data.data.respDesc);

              // console.log(res.data.data.data);
              this.servantIdCardPic.cidName =
                res.data.data.data.detail.idcardNameMap.idcardName;
              this.servantIdCardPic.cidNumber =
                res.data.data.data.detail.idcardNoMap.idcardNo;
              this.servantIdCardPic.cidAddr =
                res.data.data.data.detail.addressMap.address;
              this.servantIdCardPic.validPeriodDate =
                res.data.data.data.detail.validDateMap.validDate;
              this.servantIdCardPic.cidGender =
                res.data.data.data.detail.sexMap.sex;
              if (
                !this.isEmptyObjVue(
                  res.data.data.data.detail.birthdayMap.birthday
                )
              ) {
                this.servantIdCardPic.age =
                  new Date().getFullYear() -
                  res.data.data.data.detail.birthdayMap.birthday.substring(
                    0,
                    4
                  ) *
                  1;
                console.log(
                  "this.servantIdCardPic.age",
                  this.servantIdCardPic.age
                );
              }
              if (
                !this.isEmptyObjVue(
                  res.data.data.data.detail.validDateMap.validDate
                )
              ) {
                let validDateVal =
                  res.data.data.data.detail.validDateMap.validDate;
                let indexX = validDateVal.indexOf("-");
                let start = validDateVal.slice(0, indexX);
                let end = validDateVal.slice(indexX + 1);
                this.servantIdCardPic.idValidityEnddate =
                  end.slice(0, 4) + "-" + end.slice(5, 7) + "-" + end.slice(8);
                this.servantIdCardPic.idValidityStartdate =
                  start.slice(0, 4) +
                  "-" +
                  start.slice(5, 7) +
                  "-" +
                  start.slice(8);
              }
              let idCardval = res.data.data.data.detail.idcardNoMap.idcardNo;
              if (!this.isEmptyObjVue(idCardval) && idCardval.length == 18) {
                let year = idCardval.substring(6, 10);
                let month = idCardval.substring(10, 12);
                let day = idCardval.substring(12, 14);
                //生日
                this.servantIdCardPic.birthday = year + "-" + month + "-" + day;
                //属相
                var arr1 = [
                  "猴",
                  "鸡",
                  "狗",
                  "猪",
                  "鼠",
                  "牛",
                  "虎",
                  "兔",
                  "龙",
                  "蛇",
                  "马",
                  "羊",
                ];
                this.servantIdCardPic.logicAnimalSign = /^\d{4}$/.test(year)
                  ? arr1[year % 12]
                  : "-";
                //星座
                var s = "魔羯水瓶双鱼白羊金牛双子巨蟹狮子处女天秤天蝎射手魔羯";
                var arr2 = [20, 19, 21, 21, 21, 22, 23, 23, 23, 23, 22, 22];
                this.servantIdCardPic.logicZodiac =
                  s.substr(month * 2 - (day < arr2[month - 1] ? 2 : 0), 2) +
                  "座";
                this.servantHandleInfo.logicZodiac =
                  this.servantIdCardPic.logicZodiac;

                //名族
                this.servantHandleInfo.nation =
                  res.data.data.data.detail.nationMap.nation;

                //籍贯
                var CityArray = {
                  11: "北京市",
                  12: "天津市",
                  13: "河北省",
                  14: "山西省",
                  15: "内蒙古自治区",
                  21: "辽宁省",
                  22: "吉林省",
                  23: "黑龙江省",
                  31: "上海市",
                  32: "江苏省",
                  33: "浙江省",
                  34: "安徽省",
                  35: "福建省",
                  36: "江西省",
                  37: "山东省",
                  41: "河南省",
                  42: "湖北省",
                  43: "湖南省",
                  44: "广东省",
                  45: "广西省",
                  46: "海南省",
                  50: "重庆市",
                  51: "四川省",
                  52: "贵州省",
                  53: "云南省",
                  54: "西藏自治区",
                  61: "陕西省",
                  62: "甘肃省",
                  63: "青海省",
                  64: "宁夏回族自治区",
                  65: "新疆维吾尔自治区",
                  71: "台湾省",
                  81: "香港特别行政区",
                  82: "澳门特别行政区",
                  91: "外籍",
                };
                this.servantIdCardPic.logicBornplace =
                  CityArray[parseInt(idCardval.substr(0, 2))];
                //性别
                if (parseInt(idCardval.substr(16, 1)) % 2 == 1) {
                  this.servantIdCardPic.gender = "1";
                } else {
                  this.servantIdCardPic.gender = "2";
                }
              }
            } else if (res.data.data.overCode == -1) {
              this.$message.warning(res.data.data.overMsg);
            }
          } else {
            this.$message.warning(res.data.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$loading.hide();
        });
    },

    //定时查询身份证信息
    getIdCardInfo() {
      workercrmapi
        .$ajaxselectByAccountAndDate({
          userAccount: this.userAccount,
          date: this.date,
        })
        .then((res) => {
          if (this.isEmptyObjVue(res.data.data)) {
            this.readMsgState = false;
            console.log(this.readMsgState);
            return;
          }
          if (!this.isEmptyObjVue(res.data.data)) {
            this.readMsgState = true;
            console.log(this.readMsgState);
            // this.servantHandleInfo = res.data.data;

            this.servantHandleInfo.cidName = res.data.data.cidName;
            this.servantHandleInfo.cidNumber = res.data.data.cidNumber;
            this.servantHandleInfo.cidAddr = res.data.data.cidAddr;
            this.servantHandleInfo.logicBornplace =
              res.data.data.logicBornplace;
            this.servantHandleInfo.logicAnimalSign =
              res.data.data.logicAnimalSign;
            this.servantHandleInfo.cidBirthday = res.data.data.cidBirthday;
            this.servantHandleInfo.logicZodiac = res.data.data.logicZodiac;
            this.servantHandleInfo.cidGender = res.data.data.cidGender + "";
            this.servantHandleInfo.cidValidityStartdate =
              res.data.data.cidValidityStartdate;
            this.servantHandleInfo.cidValidityEnddate =
              res.data.data.cidValidityEnddate;
            this.servantHandleInfo.cidGender = res.data.data.cidGender + "";
            if (!this.isEmptyObjVue(this.servantHandleInfo.cidBirthday)) {
              this.age =
                new Date().getFullYear() -
                this.servantHandleInfo.cidBirthday.substring(0, 4) * 1;
              this.servantHandleInfo.birthday = moment(
                this.servantHandleInfo.cidBirthday
              ).format("YYYY-MM-DD");
            }
            if (
              !this.isEmptyObjVue(this.servantHandleInfo.cidValidityStartdate)
            ) {
              this.servantHandleInfo.startTime = moment(
                this.servantHandleInfo.cidValidityStartdate
              ).format("YYYY-MM-DD");
              this.servantHandleInfo.endTime = moment(
                this.servantHandleInfo.cidValidityEnddate
              ).format("YYYY-MM-DD");
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    switchIdReadWays(type) {
      this.isIdcard = !this.isIdcard;
      console.log("切换", this.isIdcard);
      if (this.isIdcard == false) {
        this.$message.success("成功切换为身份证OCR识别！");
        clearInterval(this.mysetInterval); // 清除定时器
        this.mysetInterval = null;
      }
      if (this.isIdcard == true) {
        this.$message.success("成功切换为身份证读卡器识别！");
        this.servantIdCardPic = {
          //清楚orc识别过的信息
          cidName: "",
          cidNumber: "",
          cidAddr: "",
          logicBornplace: "",
          birthday: "",
          logicAnimalSign: "",
          frontIdcardFullPath: "",
          frontIdcardName: "",
          backIdcardFullPath: "",
          backIdcardName: "",
          validPeriodDate: "",
          age: "",
          idValidityEnddate: "",
          idValidityStartdate: "",
          frontIdcardurl: "",
          backIdcardurl: "",
        };
        this.mysetInterval = setInterval(() => {
          if (this.intervalTimes++ >= 3600) {
            clearInterval(this.mysetInterval);
            this.intervalTimes = 0;
            this.TimeFlag = true;
          } else {
            this.getIdCardInfo();
          }
        }, 1000);
      }
    },
    //身份证隐藏中间部分
    formatidcard(idcard) {
      return idcard.replace(/^(.{6})(?:\d+)(.{4})$/, "$1********$2");
    },
    //取消新增
    cancelAddServantBtn(formName) {
      this.$nextTick(() => {
        this.$refs[formName].resetFields();
      });
      this.addVisible = false;
    },
    //上传身份证正面
    handleOnChangeA(file, fileListA) {
      // console.log(file);
      console.log(file);
      console.log("文件大小：", file.raw.size / 1024 / 1024 + "M");
      this.fileFrontPhoto =file.raw;
      /*if (file.raw) {
        lrz(file.raw, { quality: 0.9 }).then((rst) => {
          this.fileFrontPhoto = rst.origin;
          console.info(this.fileFrontPhoto);
        }).cache(res=>{
          console.info(5);
          console.info(res);
        });
      }*/
    },
    //上传身份证反面
    handleOnChangeB(file, fileListA) {
      console.log(file.raw);
      console.log("文件大小：", file.raw.size / 1024 / 1024 + "M");
      this.fileBackPhoto =file.raw
     /* if (file.raw) {
        lrz(file.raw, { quality: 0.9 }).then((rst) => {
          this.fileBackPhoto = rst.origin;
        }).cache(res=>{
          console.info(6);
          console.info(res);
        });
        console.info(2);
        console.info(this.fileBackPhoto);
      }*/
    },
    beforeAvatarUploadA(file) {
      console.log("jianlai", file);
      const isJPG = file.type === "image/jpeg" || "image/jpg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 5;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG/PNG/JEPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
      }
      return isJPG && isLt2M;
    },
    handleRemoveA(file, fileListA) {
      console.log(file, fileListA);
      console.log("关闭");
      this.fileFrontPhoto = null;

      this.servantIdCardPic = {
        cidName: "",
        cidNumber: "",
        cidAddr: "",
        logicBornplace: "",
        birthday: "",
        logicAnimalSign: "",
        frontIdcardFullPath: "",
        frontIdcardName: "",
        backIdcardFullPath: "",
        backIdcardName: "",
        validPeriodDate: "",
        age: "",
        idValidityEnddate: "",
        idValidityStartdate: "",
        frontIdcardurl: "",
        backIdcardurl: "",
      };
    },
    handleRemoveB(file, fileListB) {
      console.log(file, fileListB);
      this.fileBackPhoto = null;

      this.servantIdCardPic = {
        cidName: "",
        cidNumber: "",
        cidAddr: "",
        logicBornplace: "",
        birthday: "",
        logicAnimalSign: "",
        frontIdcardFullPath: "",
        frontIdcardName: "",
        backIdcardFullPath: "",
        backIdcardName: "",
        validPeriodDate: "",
        age: "",
        idValidityEnddate: "",
        idValidityStartdate: "",
        frontIdcardurl: "",
        backIdcardurl: "",
      };
      console.log("关闭");
    },
    cancelAddWorkExpBtn(formName) {
      this.$nextTick(() => {
        this.$refs[formName].resetFields();
      });
      this.workExpVisible = false;
    },

    //新增工作经历
    confAddWorkExpBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let agent = {};
          agent.startTime = moment(this.servantWorkExpForm.startTime).format(
            "YYYY-MM-DD"
          );
          agent.endTime = moment(this.servantWorkExpForm.endTime).format(
            "YYYY-MM-DD"
          );
          agent.content = this.servantWorkExpForm.workDesc;
          agent.sketch = this.servantWorkExpForm.workContent;
          this.workExperienceData.push(agent);
          this.servantWorkExpForm = {};
          this.workExpVisible = false;
        } else {
        }
      });
    },
    getWorkerManager() {//获取所有商家运营
      workercrmapi.$axiosWorkerManagerAll().then(res => {
        this.workerManager = res.data.data;
      })
    },
  },
};
</script>
<style scoped>
.servantHandleInfo .el-form-item--mini.el-form-item,
.servantHandleInfo .el-form-item--small.el-form-item {
  margin-bottom: 15px !important;
}

.share-servant-wrapper {
  text-align: right;
  font-size: 16px;
  padding: 0 20px 0 0;
}

/* .el-input--suffix{
display: flex;
}
.el-input-group__append{
  line-height: 32px !important;
} */
.el-form--inline .el-form-item {
  margin-right: 0px;
}

.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 5px;
}
</style>
